import * as Sentry from "@sentry/browser"

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string

let initialized = false

export function initSentry() {
  if (initialized || typeof window === "undefined" || !SENTRY_DSN) return
  Sentry.init({
    dsn: SENTRY_DSN,
    enabled: import.meta.env.PROD,
    environment: import.meta.env.DEV ? "development" : "production",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
  })
  initialized = true
}

export function captureException(
  error: unknown,
  context?: Record<string, unknown>,
) {
  if (!initialized) return
  Sentry.captureException(error, context ? { extra: context } : undefined)
}

export function setUser(
  user: { id: string; email?: string; name?: string } | null,
) {
  if (!initialized) return
  if (user) {
    Sentry.setUser({ id: user.id, email: user.email, username: user.name })
  } else {
    Sentry.setUser(null)
  }
}
